import { type Subscription } from "@/types/subscription";

export function getMonthRange(month: number, year: number) {
  const start = new Date(year, month, 1);
  const end = new Date(year, month + 1, 0, 23, 59, 59, 999);
  return { start, end };
}

export function isWithin(
  date: Date | null,
  range: { start: Date; end: Date },
): boolean {
  if (!date) return false;
  return date >= range.start && date <= range.end;
}

export function shouldDisplay(
  sub: Subscription,
  month: number,
  year: number,
): boolean {
  const monthRange = getMonthRange(month, year);

  if (sub.status === "active" || sub.status === "trial") {
    return (
      (sub.nextPayment && isWithin(sub.nextPayment, monthRange)) ||
      sub.paymentHistory.some((p) => isWithin(p.date, monthRange))
    );
  }

  if (sub.status === "cancelled") {
    return (
      (sub.cancellationDate && isWithin(sub.cancellationDate, monthRange)) ||
      sub.paymentHistory.some((p) => isWithin(p.date, monthRange)) ||
      sub.subscriptionPeriods.some(
        (period) => period.endDate && isWithin(period.endDate, monthRange),
      )
    );
  }

  if (sub.status === "paused") {
    return sub.lifecycleEvents.some(
      (e) =>
        ["paused", "resumed"].includes(e.event) && isWithin(e.date, monthRange),
    );
  }

  return false;
}
